"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var invariant=function(r,e){for(var t=arguments.length,n=Array(t>2?t-2:0),a=2;t>a;a++)n[a-2]=arguments[a];if(void 0===e)throw new Error("Invariant requires an error message argument");r||!function(){var r=0,t=new Error("Invariant Violation: "+e.replace(/%s/g,function(){return n[r++]}));throw t}()};exports["default"]=invariant,module.exports=exports["default"];


//////////////////
// WEBPACK FOOTER
// /walletexpnodeweb-ci-6534/workspace/consumerweb-release/~/invariant-slim/dist/invariant.js
// module id = 778
// module chunks = 0